import { Component, OnInit, Input, Output, EventEmitter, ViewChildren} from '@angular/core';

@Component({
  selector: 'app-create-coupon-steps',
  templateUrl: './create-coupon-steps.component.html',
  styleUrls: ['./create-coupon-steps.component.scss']
})
export class CreateCouponStepsComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Input() step: number; // Selected step
  @Output() stepSelection = new EventEmitter(); // Step selection event

  constructor() { }

  ngOnInit(): void {
  }

  // On step selection
  async onStepClick(step: number) {
    this.stepSelection.emit({ step : step });
  }

}
